/// <amd-module name="Build/SourceProviders/TfsVersionControl" />
import { Base } from "Build/SourceProviders/Base";
import {
    IBranchInfo,
    ICommitInfo,
    IProjectInfo,
    IRepositoryInfo,
    RepositoryTypes
    } from "Build/SourceProviders/Common";
import * as Resources from "Build/SourceProviders/Resources";
import { IVCNavigationService } from "VC/Common/Navigation";
import { ITfvcRestClient } from "VC/Common/RestClient/Tfvc";
import { TfvcShelvesetRequestData, TfvcShelvesetRef } from "VC/Common/Contracts/Git";

import { startsWith } from "VSS/Core/Util/String";

export class TfsVersionControl extends Base {
    private _tfvcClient: Promise<ITfvcRestClient> | undefined;
    private static s_tfvcPrefix = "$/";
    public getKey() {
        return RepositoryTypes.TfsVersionControl;
    }

    public getName() {
        return Resources.TfsVersionControl;
    }

    public getCommitIconName(): string {
        return "DocumentSet";
    }

    public getRepoIconName(): string {
        return "TFVCLogo";
    }

    public getNormalizedBranch(branch: string, projectInfo: IProjectInfo) {
        branch = branch || "";
        return branch.replace(projectInfo.id, projectInfo.name);
    }

    public getNormalizedCommit(commit: string) {
        if (commit && !isNaN(parseInt(commit))) {
            // This is changeset
            commit = "C" + commit;
        }

        return commit;
    }

    public fetchBranchLink(info: IBranchInfo, projectName?: string) {
        return this.vcNavigationService.then((service) => {
            return this._getBranchLink(info, service, projectName);
        });
    }

    public fetchCommitLink(info: ICommitInfo, projectName?: string) {
        return this.vcNavigationService.then((service) => {
            return this._getCommitLink(info, service, projectName);
        });
    }

    public fetchRepositoryLink(info: IRepositoryInfo, projectName?: string): Promise<string | null> {
        return this.vcNavigationService.then((service) => {
            return this._getRepositoryLink(info, service, projectName);
        });
    }

    protected _getBranchLink(info: IBranchInfo, service: IVCNavigationService, projectName?: string) {
        const branchName = info.branchName;
        if (startsWith(branchName, TfsVersionControl.s_tfvcPrefix)) {
            return service.getRefUrl(info.branchName, null, projectName);
        }
        else {
            return service.getTfvcCommitUrl(info.branchName);
        }
    }

    protected _getCommitLink(info: ICommitInfo, service: IVCNavigationService, projectName?: string) {
        return service.getTfvcCommitUrl(this.getNormalizedCommit(info.commitId), projectName);
    }

    protected _getRepositoryLink(info: IRepositoryInfo, service: IVCNavigationService, projectName?: string): string {
        return service.getRepositoryUrl(null, projectName);
    }

    private get tfvcClient(): Promise<ITfvcRestClient> {
        if (!this._tfvcClient) {
            this._tfvcClient = this.getVcCode().then(() => {
                return this.pageContext.getRestClient<ITfvcRestClient>("ITfvcRestClient");
            });
        }

        return this._tfvcClient;
    }

    public fetchShelvesets(owner: string): Promise<TfvcShelvesetRef[]> {
        const requestData = { owner: owner} as TfvcShelvesetRequestData;
        return this.tfvcClient.then((client) => {
            return client.getShelvesets(requestData).then((shelvesets) => {
                return shelvesets;
            });
        });
    }
}
